<!-- ADD AND EDIT DIALOG -->
<kendo-dialog *ngIf="active" [width]="950" class="kendo-popup app-dialog" id="edit-import-dialog" (close)="closePopup()">
  <kendo-dialog-titlebar>
    {{ isNewRecord ? 'Add New Record' : 'Edit Record' }}
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm" class="ie-btn-display" id="editRecordForm">
    <div *ngIf="isErr" id="recordError" class="error-container">
      <h2 class="header-tag">Errors:</h2>
      <ul class="recordIssues" id="recordErrorName">
        <li *ngFor="let error of recordErrors"><span class="k-icon k-i-error text-red"></span>
          {{error}}
        </li>
      </ul>
    </div>
    <div *ngIf="isIssue" class="issue-container" id="recordIssue">
      <h2 class="header-tag">Warnings:</h2>
      <ul class="recordIssues" id="recordIssuesName">
        <li *ngFor="let issue of recordIssues"><span class="k-icon k-i-warning text-warning"></span>
          {{issue}}
        </li>
      </ul>
    </div>

    <div id="identity">
      <p class="form-label"><span class="bold headingtext">Personal Details</span></p>
      <div class="user-detail">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div class="col s12 m12 l12 xl12">
                  <label for="ssn" class="control-label">SSN<span class="k-required">*</span></label>
                  <kendo-maskedtextbox id="ssn" [mask]="ssnMask" formControlName="ssn"></kendo-maskedtextbox>
                  <div class="top-margin-1">
                    <span class="tooltip-validation"
                      *ngIf="editForm.controls.ssn.touched && editForm.controls.ssn.errors">
                      Valid SSN is required
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div class="col s5 m5 l5 xl5">
                  <div>
                    <label for="firstName" class="control-label">First Name<span class="k-required">*</span></label>
                    <input type="text" id="firstName" maxlength="12" class="k-textbox kendo-textbox" formControlName="firstName" />
                    <div class="top-margin-1">
                      <span class="tooltip-validation"
                        *ngIf="editForm.controls.firstName.touched && editForm.controls.firstName.errors">
                        Valid First Name is required
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col s2 m2 l2 xl2">
                  <div class="dsp-inlineBlock">
                    <label for="middleInitials" class="control-label">MI</label>
                    <input type="text" id="middleInitials" (keyup)="trimContent($event)" maxlength="1" class="k-textbox" formControlName="middleInitials" />
                  </div>
                </div>
                <div class="col s5 m5 l5 xl5">
                  <div>
                    <label for="lastName" class="control-label">Last Name<span class="k-required">*</span></label>
                    <input type="text" id="lastName" maxlength="17" class="k-textbox" formControlName="lastName" />
                    <div class="top-margin-1">
                      <span class="tooltip-validation"
                        *ngIf="editForm.controls.lastName.touched && editForm.controls.lastName.errors">
                        Valid Last Name is required
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <p class="form-label"><span class="bold headingtext">Address</span></p>
      <div class="user-address">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group addr-style">
              <div class="input-validation">
                <div class="col s6 m6 l6 xl6">
                  <div>
                    <label for="addressLine1" class="control-label">Address1<span class="k-required">*</span></label>
                    <input type="text" class="k-textbox" maxlength="35" id="addressLine1" formControlName="addressLine1" />
                    <div class="top-margin-1">
                      <span class="tooltip-validation"
                        *ngIf="editForm.controls.addressLine1.touched && editForm.controls.addressLine1.errors">
                        Address1 is required
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col s6 m6 l6 xl6">
                  <div>
                    <label for="addressLine2" class="control-label">Address2</label>
                    <input type="text" class="k-textbox" maxlength="35" id="addressLine2" formControlName="addressLine2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group location-style">
              <div class="input-validation">
                <div class="col s4 m4 l4 xl4">
                  <div>
                    <label for="city" class="control-label" id="city-name">City<span class="k-required">*</span></label>
                    <input type="text" id="city" maxlength="33" class="k-textbox" formControlName="city" />
                    <div class="top-margin-1">
                      <span class="tooltip-validation"
                        *ngIf="editForm.controls.city.touched && editForm.controls.city.errors">
                        Valid City is required
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col s4 m4 l4 xl4">
                  <div>
                    <label for="state" id="state-label" class="control-label">State<span
                        class="k-required">*</span></label>
                    <kendo-dropdownlist id="state" name="defaultState" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="defaultState" [data]="states" [textField]="'name'" [valueField]="'abbreviation'">
                    </kendo-dropdownlist>
                    <div class="top-margin-1">
                      <span class="tooltip-validation"
                        *ngIf="editForm.controls.state.touched && editForm.controls.state.errors">
                        State is required
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col s2 m2 l2 xl2">
                  <div>
                    <label for="zip" class="control-label" id="zip-label">Zip<span class="k-required">*</span></label>
                    <kendo-maskedtextbox id="zip" [mask]="zipMask" class="masked-margin0" formControlName="zip">
                    </kendo-maskedtextbox>
                    <div class="top-margin-1">
                      <span class="zip tooltip-validation left-margin-55"
                        *ngIf="editForm.controls.zip.touched && editForm.controls.zip.errors">
                        Enter valid zip
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col s2 m2 l2 xl2">
                  <div class="dsp-inlineBlock">
                    <label for="zip4" class="control-label" id="zip4-label">Zip+4</label>
                    <kendo-maskedtextbox id="zip4" [mask]="zip4Mask" class="masked-margin" formControlName="zip4">
                    </kendo-maskedtextbox>
                    <div class="top-margin-1">
                      <span class="zip4 tooltip-validation left-margin-34"
                        *ngIf="editForm.controls.zip4.touched && editForm.controls.zip4.errors">
                        Enter valid zip4
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="membership-style">
      <p class="form-label"><span class="bold headingtext">Membership</span></p>
      <div class="membership">
        <div class="row">
          <div class="col s12 m12 l12 xl12">
            <div class="form-group">
              <div class="input-validation">
                <div class="col s7 m7 l7 xl7">
                  <div class="dsp-inlineBlock">
                    <label for="locationCode" class="control-label kendo-location">Location<span class="k-required">*</span></label>
                    <kendo-dropdownlist id="locationCode" name="defaultLocation" [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="defaultLocation" (valueChange)="onValueChanges($event, 'locationCode')"
                      [defaultItem]="defaultItem" [data]="userLocations" [textField]="'name'" [valueField]="'id'">
                    </kendo-dropdownlist>
                  </div>
                </div>
                <div class="col s5 m5 l5 xl5">
                  <div class="dsp-inlineBlock">
                    <label for="systemCode" id="system-label" class="control-label">System<span class="k-required">*</span></label>
                    <kendo-dropdownlist id="systemCode" name="defaultSystem" [ngModelOptions]="{standalone: true}"
                      [defaultItem]="defaultSysItem" (valueChange)="onValueChanges($event, 'systemCode')"
                      [(ngModel)]="defaultSystem" [data]="systems" [textField]="'name'" [valueField]="'id'">
                    </kendo-dropdownlist>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <p class="form-label"><span class="bold headingtext">Pay</span></p>
      <div class="pay">
        <div class="row">
          <table class="keyValuePairs fill paydetails-style" id="payTable" aria-hidden="true">
            <tbody id="payBody">
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="payPeriodEndDate" class="head-label">Pay Period End Date</label>
                  <em class="head-label left-margin-5">(PPED)</em>
                </th>
                <td>
                  <div class="input-validation">
                    <span id="payPeriodEndDate">{{pped}}</span>
                  </div>
                </td>
              </tr>

              <tr>
                <th scope="row" class="kendo-th">
                  <label for="actualAnnualCompensation" class="head-label">Actual Annual
                    Compensation</label><em class="head-label left-margin-5">(Dollars
                    only, no cents)</em><span class="k-required">*</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="actualAnnualCompensation" [format]="'c0'"
                     formControlName="actualAnnualCompensation" (input)="setIntMaxVal('actualAnnualCompensation');"></kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class="errmsg left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.actualAnnualCompensation.touched && editForm.controls.actualAnnualCompensation.errors">
                        <span *ngIf="editForm.controls.actualAnnualCompensation.errors.max; else noMaxErr">Max
                          AAC limit is {{maxAEC}}</span>
                        <ng-template #noMaxErr> {{invalidAAC}}</ng-template>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="actualEarnableCompensation" class="head-label">Annual Earnable
                    Compensation</label><em class="head-label left-margin-5">(Dollars
                    only, no cents)</em><span class="k-required">*</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="actualEarnableCompensation" [format]="'c0'"
                      formControlName="actualEarnableCompensation" (input)="setIntMaxVal('actualEarnableCompensation');">
                    </kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class=" errmsg left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.actualEarnableCompensation.touched && editForm.controls.actualEarnableCompensation.errors">
                        <span *ngIf="editForm.controls.actualEarnableCompensation.errors.max; else noMaxAECErr">Max
                          AEC limit is {{maxAEC}}</span>
                        <ng-template #noMaxAECErr> {{invalidAEC}}</ng-template>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="employeeContribution" class="head-label">Employee
                    Contribution</label><em class="head-label left-margin-5">(Dollars
                    and cents, with decimal)</em><span class="k-required">*</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="employeeContribution" [format]="'c2'" [decimals]="'2'"
                      formControlName="employeeContribution" (input)="setDecMaxVal('employeeContribution');"></kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class="left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.employeeContribution.touched && editForm.controls.employeeContribution.errors">
                        {{invalidContribution}}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="payPeriodBaseSalary" class="head-label">Pay Period Base
                    Salary</label><em class="head-label left-margin-5">(Dollars
                    and cents, with decimal)</em><span class="k-required">*</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="payPeriodBaseSalary" [format]="'c2'" [decimals]="'2'"
                      [min]="min" [max]="maxPBS" formControlName="payPeriodBaseSalary" (input)="setDecMaxVal('payPeriodBaseSalary');"></kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class="left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.payPeriodBaseSalary.touched && editForm.controls.payPeriodBaseSalary.errors">
                        {{invalidPPBaseSalary}}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="hoursWorked" class="head-label">Hours Worked</label><em class="head-label left-margin-5">(To one decimal
                    point, ex. 80.0)</em><span class="k-required">*</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="hoursWorked" [format]="'n1'" [decimals]="'1'" [autoCorrect]="autoCorrect" [min]="min"
                      [max]="maxHW" formControlName="hoursWorked"></kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class="left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.hoursWorked.touched && editForm.controls.hoursWorked.errors">
                        {{invalidHoursWork}}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="standardHours" class="head-label">Standard Hours</label><em class="head-label left-margin-5">(To one
                    decimal
                    point, ex. 80.0)</em><span class="k-required">*</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="standardHours" [format]="'n1'" [decimals]="'1'"  [autoCorrect]="autoCorrect" [min]="min"
                      [max]="maxSH" formControlName="standardHours"></kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class="left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.standardHours.touched && editForm.controls.standardHours.errors">
                        {{invalidStandardHours}}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row" class="kendo-th">
                  <label for="percentFullTime" class="head-label">Percent FullTime</label>
                  <em class="head-label left-margin-5">(No decimal or percent sign)</em><span class="k-required">*</span>
                  <span style="float:right">%</span>
                </th>
                <td>
                  <div class="input-validation">
                    <kendo-numerictextbox id="percentFullTime" [format]="'n0'" [decimals]="0" [max]="100" formControlName="percentFullTime">
                    </kendo-numerictextbox>
                    <div class="top-margin-1">
                      <span class="left-margin-0 tooltip-validation"
                        *ngIf="editForm.controls.percentFullTime.touched && editForm.controls.percentFullTime.errors">
                        <span
                          *ngIf="editForm.controls.percentFullTime.errors.max||editForm.controls.percentFullTime.errors.min; else notValidFT">{{invalidFTRange}}</span>
                        <ng-template #notValidFT>{{invalidFT}}</ng-template>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </form>
  <kendo-dialog-actions id="editRecordBtn">
    <button kendoButton id="cancelBtn" [disabled]="isProcessing" (click)="onCancel($event)" primary="true">Cancel</button>
    <button id="saveBtn" kendoButton (click)="onSave($event)"
      [disabled]="!editForm.valid || isProcessing">
      <span *ngIf="!isProcessing">Save</span>
      <span *ngIf="isProcessing" class="k-icon k-i-loading inner"></span>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- ERROR AND ISSUE DIALOG -->
<kendo-dialog title="Errors & Warnings" class="app-dialog" *ngIf="displaySubmitPopUp" id="errIssDialog" (click)="closeForm()">
  <h2 class="header-tag">{{errorAndIssueMsg}}</h2>

  <div *ngIf="isErr">
    <h2>Errors:</h2>
    <ul class="recordIssues">
      <li *ngFor="let error of recordErrors" id="errorMsg"><span class="k-icon k-i-error text-red"></span>
        {{error}}
      </li>
    </ul>
  </div>
  <div *ngIf="isIssue">
    <h2>Warnings:</h2>
    <ul class="recordIssues">
      <li *ngFor="let issue of recordIssues" id="issueMsg"> <span class="k-icon k-i-warning text-warning"></span>
        {{issue}}
      </li>
    </ul>
  </div>

  <p id="warningMsg">{{continueMsg}}</p>
  <kendo-dialog-actions id="errorAndIssueDialogBtn">
    <button kendoButton (click)="closeForm()" id="cancelBtn" primary="true">No</button>
    <button kendoButton (click)="displaySubmitPopUp=false" primary="true" id="continueBtn">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
